// extracted by mini-css-extract-plugin
export default {"tableBodyRow":"tableBody_tableBodyRow__NN+k7","allowCLick":"tableBody_allowCLick__znPMj"};